import React from "react";
import { LIBRARIES_THEME } from "../librariesTheme";

const fieldClass = `w-full h-9 px-3 text-sm rounded-md border border-indigo-200 bg-white text-slate-800 outline-none transition-colors ${LIBRARIES_THEME.fieldFocus}`;

/**
 * Shared labeled field for Libraries catalog forms.
 */
export const LibraryField = ({
  id,
  label,
  required,
  error,
  children,
  hint,
}) => (
  <div className="space-y-1">
    <label htmlFor={id} className="block text-xs font-semibold text-slate-700">
      {label}
      {required ? <span className="text-red-500 ml-0.5">*</span> : null}
    </label>
    {children}
    {hint ? <p className="text-[11px] text-slate-500">{hint}</p> : null}
    {error ? <p className="text-[11px] text-red-600">{error}</p> : null}
  </div>
);

export const libraryInputClass = (hasError) =>
  `${fieldClass} ${hasError ? "border-red-300 focus:border-red-400" : ""}`;

export const librarySelectClass = (hasError) =>
  `appearance-none ${libraryInputClass(hasError)} pr-8 cursor-pointer`;

export default LibraryField;
